import * as angular from 'angular';
import template from './topDefects.tpl.html';
import controller from './topDefects.controller';

export default angular.module('aps.directive.topDefects', [controller])
  .directive('apsTopDefects', topDefectsDef)
  .name;

function topDefectsDef() {
  return {
    restrict: 'E',
    template: template,
    replace: true,
    controller: 'TopDefectsCtrl',
    controllerAs: 'vm',
    bindToController: true,
    scope: {
      shop: '=',
      queryStart: '=',
      queryEnd: '=',
      maxDefects: '=',
      plantTimeZoneId: '='
    }
  };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/dashboard/topDefects.directive.ts